export default __webpack_public_path__ + "static/media/cabesp.13505870.png";